<template>
  <div class="blog-wgt">
    <v-row>
      <v-col v-for="block in blocks" :class="block.class" :key="block.id">
        <h4 class="title-module">{{block.transName}}</h4>
        <div class="blog-body">
          <div v-if="block.transImageContent" class="blog-img" v-html="block.transImageContent">
          </div>
          <div v-if="block.transContent" v-html="block.transContent"></div>
        </div>
        <div v-if="block.transFooterContent" class="blog-footer" v-html="block.transFooterContent">
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CMS from '@/model/cms'

export default {
  props: {
    widget: Object
  },
  data: () => ({
    blocks: []
  }),
  mounted () {
    CMS.loadBlocks()
      .then((response) => {
        this.blocks = response.data
      })
      .catch((error) => {
        console.log(error)
      })
  },
  methods: {
    // getImg (content) {
    //   let elContent = document.createElement('div')
    //   elContent.innerHTML = content.trim()
    //
    //   let firstImage = elContent.getElementsByTagName('img')[0]
    //
    //   if (firstImage) {
    //     return firstImage.src
    //   }
    //
    //   return false
    // }
  }
}
</script>
